import api from './index';
//
let exports = {};

exports.getDevcSelloffVoucher = function (params, callback) {// 出售单详情
    api.get('/devc/sellof/devc/selloff/voucher/get')
        .params(params)
        .done(callback)
        .fail(callback)
        .go();
};
exports.getDevcSelloffVoucherList = function (data, callback) {// 出售单分页列表
    api.post('/devc/sellof/devc/selloff/voucher/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.getDevcSelloffItemList = function (data, callback) {// 出售单明细分页列表
    api.post('/devc/sellof/devc/selloff/item/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.getDevcSelloffBuyerList = function (data, callback) {// 出售单买家列表
    api.post('/devc/sellof/devc/selloff/buyer/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.getDevcSelloffBundlePriceRecList = function (data, callback) {// 出价记录分页列表
    api.post('/devc/sellof/devc/selloff/bundle/price/rec/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.doDevcSelloffVoucherPublish = function (data, callback) {// 出售单发布
    api.post('/devc/sellof/devc/selloff/voucher/publish/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.doDevcSelloffVoucherPullbck = function (data, callback) {// 出售单流拍
    api.post('/devc/sellof/devc/selloff/voucher/pullbck/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.doDevcSelloffVoucherBundlePrice = function (data, callback) {// 出售单报价
    api.post('/devc/sellof/devc/selloff/voucher/bundle/price/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.doDevcSelloffVoucherDeal = function (data, callback) {// 出售单成交
    api.post('/devc/sellof/devc/selloff/voucher/deal/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.doDevcSelloffVoucherNegoDeal = function (data, callback) {// 出售单面议成交
    api.post('/devc/sellof/devc/selloff/voucher/nego/deal/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.doDevcSelloffVoucherNegoDealConfirm = function (data, callback) {// 出售单面议成交确认
    api.post('/devc/sellof/devc/selloff/voucher/nego/deal/confirm/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/devcSelloff.js
// module id = 125
// module chunks = 0